import axios from 'axios';
import { getAnnotationUrl, getGLobalRepoUrl } from './api-services';
import urls from './urls';
import { $session } from '@/helpers';

export const saveAnnotationsFact = data => axios.post(getAnnotationUrl(), data);


export const updateAnnotationsFact = data => axios.put(getAnnotationUrl(), data);

export const deleteAnnotationsFact = id => axios.delete(getAnnotationUrl(`/${id}`));

export const reorderAnnotationsFact = (id, source, data) => axios.post(getAnnotationUrl(`${urls.order}/${id}/${source}`), data);

export const getAnnotationById = (id, token) => axios.get(getAnnotationUrl(`/${id}`), {
  headers: {
    authorization: token,
  },
});

export const copyAnnotationsForNewSlide = data => axios.post(getAnnotationUrl(`${urls.copy}`), data);

export const copyGroupChatAnnotationsFact = data => axios.post(getAnnotationUrl(`${urls.groupChat}${urls.copy}`), data);

export const createPollFact = data => axios.post(getGLobalRepoUrl(urls.poll), data);

export const updatePollFact = data => axios.put(getGLobalRepoUrl(urls.poll), data);

export const getPollsBySlideIdFact = (params) => {
  const tenantData = $session.getTenantData();
  console.log("tenantData in getPollsBySlideIdFact: ", tenantData);
  const headers = {
    "Content-Type": "application/json",
    "X-TenantId": tenantData?.id, // match direct call
  };
 return axios.get(getGLobalRepoUrl(`${urls.poll}/bySlideId`), {
  params,
  headers
}) };

export const getPollByIdFact = params => axios.get(getGLobalRepoUrl(`${urls.poll}/byPollId`), {
  params,
});

export const deletePollFact = params => axios.delete(getGLobalRepoUrl(urls.poll), {
  params,
});

export const savePollResultFact = (params) => { 
  const tenantData = $session.getTenantData();
   const headers = {
    "Content-Type": "application/json",
    "X-TenantId": tenantData?.id, // match direct call
  };
  return axios.post(
  getGLobalRepoUrl(`${urls.poll}${urls.results}`),
  null,
  { params, headers },
)};

export const getAnnotationsBySlideFact = (ids, source) => {
  return axios.post(getAnnotationUrl(`${urls.all}${urls.bySource}?source=${source}`), ids);
};

export const getAnnotationsForPublicSite = (ids, source) => {
   const tenantData =$session.getTenantData()
  return axios.post(getGLobalRepoUrl(`${urls.annotations}${urls.all}${urls.bySource}?source=${source}`), ids, {
    headers: {
      'X-TenantID': tenantData && tenantData.id ? tenantData.id : null,
    },
  });
};
